module.exports = __webpack_public_path__ + "static/Moderat-Regular-49669fe48e3fbc33bebae9bd643517da.woff";